import { useEffect } from 'react';
import { isMockAuthEnabled } from './mockAuth';

/**
 * Ensures `_form_token` exists so `getCookie` + PHP POST bodies match Vitest-style mocks.
 * Only runs when `VITE_MOCK_AUTH=true` (local / Playwright).
 */
export function MockAuthEffects() {
  useEffect(() => {
    if (!isMockAuthEnabled()) return;
    if (document.cookie.includes('_form_token=')) return;
    document.cookie = '_form_token=mock;path=/;SameSite=Lax';
  }, []);
  return null;
}
